import React from 'react'
import styled from 'styled-components'

const Loading = styled.div`
  padding: 5rem 2rem;
  text-align: center;
  font-weight: 500;
  font-size: 2.5rem;
`

export default () => <Loading>Loading...</Loading>



// WEBPACK FOOTER //
// ./src/components/Loading.js